
<app-reservas-table
  [searchable]="true"
  [reservas]="reservas"
  [showDeleteButton]="false"
  [showEditButton]="false"
  (checkReserva)="onCheckReserva($event)"
></app-reservas-table>
<nz-modal
  [(nzVisible)]="isReciboModalVisible"
  [nzTitle]="'Actualizar Número de Recibo'"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelReciboModal()"
>
  <ng-container *nzModalContent>
    <form nz-form (ngSubmit)="submitReciboForm()">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzFor="numRecibo">Número de Recibo</nz-form-label>
        <nz-form-control [nzSpan]="24" nzErrorTip="Por favor, ingrese un número de recibo válido.">
          <input
            nz-input
            id="numRecibo"
            type="text"
            [(ngModel)]="numRecibo"
            name="numRecibo"
            placeholder="Ingrese el número de recibo"
            required
          />
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelReciboModal()">Cancelar</button>
    <button nz-button nzType="primary" [disabled]="!numRecibo" (click)="submitReciboForm()">
      Actualizar
    </button>
  </ng-template>
</nz-modal>
